var map = {
	"./0.png": 74823,
	"./1.png": 22334,
	"./2.png": 8085,
	"./3.png": 72172,
	"./4.png": 48419,
	"./5.png": 84314,
	"./6.png": 5425,
	"./7.png": 95208,
	"./8.png": 25055,
	"./9.png": 28118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80212;